import { getSessionItem } from "./services/utility";

function isValid(field) {
  const helpText = field.parentNode.querySelector(".help-block");
  field.classList.remove("is-invalid");
  field.classList.add("is-valid");
  helpText && helpText.classList.add("d-none");
}

function clear(field) {
  const helpText = field.parentNode.querySelector(".help-block");
  field.classList.remove("is-invalid");
  field.classList.remove("is-valid");
  helpText && helpText.classList.add("d-none");
}

function isInvalid(field, text) {
  const helpText = field.parentNode.querySelector(".help-block");
  helpText.innerText = text;
  field.classList.remove("is-valid");
  field.classList.add("is-invalid");
  helpText && helpText.classList.remove("d-none");
}

function verify2FA() {
  const URL = `${window.location.origin}/auth/local/2fa/verify`;

  const verify2FAForm = $("#form-verify2FA");
  const verify2FABtn = $("#submit-verify2FA");
  if (!verify2FAForm) {
    return;
  }

  const verificationCodeInput = document.querySelector(
    "#form-verify2FA input[name=verificationCode]",
  );
  const recoveryCodeInput = document.querySelector(
    "#form-verify2FA input[name=recoveryCode]",
  );
  const verificationCodeGroup = document.querySelector(
    "#group-verificationCode",
  );
  const recoveryCodeGroup = document.querySelector("#group-recoveryCode");
  const recoveryCodeToggle = document.querySelector("#toggle-recoveryCode");
  const subtitle = document.querySelector("#verify2FA-subtitle");

  // The server takes either proof. Whichever field is on screen is the one
  // that gets sent — a blank second field must not read as a failed attempt.
  let useRecoveryCode = false;

  function activeInput() {
    return useRecoveryCode ? recoveryCodeInput : verificationCodeInput;
  }

  function toggleRecoveryCode(e) {
    e && e.preventDefault();
    if (!recoveryCodeGroup || !recoveryCodeInput) {
      return;
    }
    useRecoveryCode = !useRecoveryCode;

    clear(verificationCodeInput);
    clear(recoveryCodeInput);
    verificationCodeInput.value = "";
    recoveryCodeInput.value = "";

    verificationCodeGroup.classList.toggle("d-none", useRecoveryCode);
    recoveryCodeGroup.classList.toggle("d-none", !useRecoveryCode);
    recoveryCodeToggle.innerText = useRecoveryCode
      ? "Use a code from your authenticator app"
      : "Use a recovery code";
    if (subtitle) {
      subtitle.innerText = useRecoveryCode
        ? "Enter the recovery code you saved when you turned on two-factor authentication. It can only be used once."
        : "Enter the 6-digit code from your authenticator app (e.g. Google Authenticator) to finish logging in.";
    }
    activeInput().focus();
  }

  function afterSubmit(e) {
    e.preventDefault();
    const input = activeInput();
    clear(input);

    if (!input.value) {
      isInvalid(input, "This field is mandatory.");
      return;
    }

    let payload = useRecoveryCode
      ? { recoveryCode: input.value }
      : { code: input.value };

    console.log("Submitting");

    const req = $.ajax({
      url: `${URL}`,
      method: "POST",
      data: JSON.stringify(payload),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
    });

    req.done((e) => {
      const continuation = getSessionItem("federatedLinkContinuation");
      if (continuation && e?.data?.state === "AWAIT_CONFIRMATION") {
        location.href = `${window.location.origin}/login`;
        return;
      }
      const redirectUrl = e?.data?.redirectUrl || e?.data?.redirectUri;
      if (typeof redirectUrl === "string" && redirectUrl) {
        location.href = redirectUrl;
      } else {
        location.reload();
      }
    });

    req.fail((e) => {
      isInvalid(activeInput(), e.responseJSON.message);
      // console.log('e', e.responseJSON.message)
    });
  }
  if (verificationCodeInput) {
    verificationCodeInput.addEventListener(
      "keydown",
      function () {
        clear(verificationCodeInput);
      },
      false,
    );
  }
  if (recoveryCodeInput) {
    recoveryCodeInput.addEventListener(
      "keydown",
      function () {
        clear(recoveryCodeInput);
      },
      false,
    );
  }
  if (recoveryCodeToggle) {
    recoveryCodeToggle.addEventListener("click", toggleRecoveryCode, false);
  }
  verify2FABtn.on("click", afterSubmit);
  verify2FAForm.on("submit", afterSubmit);
}

export default verify2FA;
